import { InputHTMLAttributes, forwardRef } from 'react';
import styles from './styles.module.scss';

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> & {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
};

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({ 
    checked, 
    onChange,
    onClick,
    ...props 
}, ref) => {
    return (
        <input
            ref={ref}
            type="checkbox"
            className={styles.checkbox}
            checked={checked}
            onChange={(e) => onChange?.(e.target.checked)}
            onClick={(e) => {
                e.stopPropagation();
                onClick?.(e);
            }}
            {...props}
        />
    );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
